export default __webpack_public_path__ + "static/media/facebook.d214f671.svg";